/**
 * ============================================================
 * TRESTLE™ Authentication Controller
 * ------------------------------------------------------------
 * Handles complete frontend authentication lifecycle.
 *
 * Responsibilities
 * ----------------
 * • Initialize Authentication
 * • Manage Authentication State
 * • Email Validation
 * • Firebase Authentication
 * • Backend Authentication
 * • Session Management
 * • Workspace Redirection
 *
 * Parent Brand : Diafemme
 * Version      : 2.0
 * Status       : PRODUCTION
 * ============================================================
 */

'use strict';

import {
    GoogleAuthProvider,
    signInWithPopup,
    sendSignInLinkToEmail,
    isSignInWithEmailLink,
    signInWithEmailLink
} from "https://www.gstatic.com/firebasejs/12.1.0/firebase-auth.js";

/*============================================================
Authentication Controller
============================================================*/

const TrestleAuth = (() => {

    /*==========================================================
    Authentication State
    ==========================================================*/

    let currentState = TrestleConfig.AUTH.IDLE;

    /*==========================================================
    Firebase
    ==========================================================*/

    const auth = window.TrestleFirebase.auth;

    const googleProvider =

    window.TrestleFirebase.googleProvider;

    /*==========================================================
    Cached Elements
    ==========================================================*/

    let emailInput = null;

    let continueButton = null;

    let googleButton = null;

    let messageBox = null;

    let registerScreen = null;

    let registerForm = null;

    let registerEmail = null;

    let firstName = null;

    let lastName = null;

    let backButton = null;

    /*==========================================================
    Firebase Action Code
    ==========================================================*/

    const ACTION_CODE_SETTINGS = {

        url: window.location.origin + "/pages/trestle-auth",

        handleCodeInApp: true

    };

    /*==========================================================
    Initialize
    ==========================================================*/

    async function init() {

        console.log("TRESTLE Authentication Started");

        cacheElements();

        bindEvents();

        await restoreAuthentication();

    }

    /*==========================================================
    Restore Authentication
    ==========================================================*/

    async function restoreAuthentication() {

        if (

            isSignInWithEmailLink(

                auth,

                window.location.href

            )

        ) {

            await completeMagicLinkLogin();

        }

    }

    /*==========================================================
    Cache Elements
    ==========================================================*/

    function cacheElements() {

        emailInput =

            document.getElementById("tr-email");

        continueButton =

            document.getElementById("tr-register-btn");

        googleButton =

            document.getElementById("tr-google-btn");

        messageBox =

            document.getElementById("tr-message");

        registerScreen =

            document.getElementById("tr-screen-register");

        registerForm =

            document.getElementById("tr-register-form");

        registerEmail =

            document.getElementById("tr-register-email");

        firstName =

            document.getElementById("tr-first-name");

        lastName =

            document.getElementById("tr-last-name");

        backButton =

            document.getElementById("tr-back-to-welcome");

    }

    /*==========================================================
    Bind Events
    ==========================================================*/

   function bindEvents() {

    const emailForm =

        document.querySelector(".tr-auth-form");

    if (emailForm) {

        emailForm.addEventListener(

            "submit",

            handleEmailSubmit

        );

    }

    if (googleButton) {

        googleButton.addEventListener(

            "click",

            handleGoogleLogin

        );

    }

    if (registerForm) {

        registerForm.addEventListener(

            "submit",

            handleRegistrationSubmit

        );

    }

    if (backButton) {

        backButton.addEventListener(

            "click",

            handleBack

        );

    }

}

    /*==========================================================
    State
    ==========================================================*/

    function setState(state) {

        currentState = state;

        console.log(

            "AUTH STATE:",

            currentState

        );

    }
     function getState() {

    return currentState;

    }




    /*==========================================================
    Email Submission
    ==========================================================*/

    async function handleEmailSubmit(event) {

        event.preventDefault();

        console.count("EMAIL SUBMIT");

        clearMessage();

        const email =

            emailInput.value.trim().toLowerCase();

        if (!validateEmail(email)) {

            showError(

                TrestleConfig.MESSAGE.INVALID_EMAIL

            );

            return;

        }

        try {

            setState(

                TrestleConfig.AUTH.SENDING_LINK

            );

            showLoading(true);

            console.log("Sending email link...");

            await sendSignInLinkToEmail(

                auth,

                email,

                ACTION_CODE_SETTINGS

            );
            console.log("Firebase accepted sign-in link for:", email);

            localStorage.setItem(

                TrestleConfig.SESSION.STORAGE_KEY,

                email

            );

            setState(

                TrestleConfig.AUTH.LINK_SENT

            );

            showSuccess(

                TrestleConfig.MESSAGE.MAGIC_LINK_SENT

            );

        }

        catch (error) {

            console.error("Firebase Error:", error);
console.error("Firebase Error Code:", error.code);
console.error("Firebase Error Message:", error.message);

            setState(

                TrestleConfig.AUTH.ERROR

            );

            console.error(error);

showError(

    "Google Sign-In failed. Please try again."

);

        }

        finally {

            showLoading(false);

        }

    }

    /*==========================================================
    Complete Magic Link Login
    ==========================================================*/

    async function completeMagicLinkLogin() {

        let email =

            localStorage.getItem(

                TrestleConfig.SESSION.STORAGE_KEY

            );

        if (!email) {

            email = window.prompt(

                "Confirm your email address"

            );

        }

        if (!email) {

            return;

        }

        try {

            showLoading(true);

            const credential =

                await signInWithEmailLink(

                    auth,

                    email,

                    window.location.href

                );

            localStorage.removeItem(

                TrestleConfig.SESSION.STORAGE_KEY

            );

            setState(

                TrestleConfig.AUTH.AUTHENTICATED

            );

            await authenticateBackend(

                credential.user

            );

        }

        catch (error) {

            console.error(error);

            showError(

                error.message

            );

        }

        finally {

            showLoading(false);

        }

    }
    /*==========================================================
Google Authentication
==========================================================*/

async function handleGoogleLogin() {

    try {

        clearMessage();

        showLoading(true);

        const result = await signInWithPopup(

            auth,

            googleProvider

        );

        console.log(

            "Google Login Successful",

            result.user

        );

        const backendResponse =

    await authenticateBackend(

        result.user

    );

console.log(

    "BACKEND RESPONSE",

    backendResponse

);

    }

    catch (error) {

        console.error(

            "Google Authentication Error",

            error

        );

        showError(

            error.message

        );

    }

    finally {

        showLoading(false);

    }

}

    /*==========================================================
    Backend Authentication
    ==========================================================*/

    async function authenticateBackend(firebaseUser) {

        const response =

            await TrestleAPI.authenticateUser(

    {

        uid: firebaseUser.uid,

        email: firebaseUser.email,

        emailVerified: firebaseUser.emailVerified

    },

    {}

);

console.log("========== BACKEND RESPONSE ==========");
console.log(response);
console.log("======================================");

       if (!response.success) {

    throw new Error(

        response.message

    );

}

if (response.isNewUser) {

    showRegistrationScreen(

        firebaseUser.email

    );

    return;

}

storeSession(

    response.data

);

    }

    /*==========================================================
    Store Session
    ==========================================================*/

    function storeSession(session) {

        localStorage.setItem(

            TrestleConfig.SESSION.USER_ID,

            session.userId

        );

        localStorage.setItem(

            TrestleConfig.SESSION.WORKSPACE_ID,

            session.workspaceId

        );

        localStorage.setItem(

            TrestleConfig.SESSION.SESSION_TOKEN,

            session.sessionToken

        );

        setState(

            TrestleConfig.AUTH.READY

        );

        redirectToWorkspace();

    }
    /*==========================================================
    Registration Screen
    ==========================================================*/

    function showRegistrationScreen(email) {

        if (registerScreen) {

            registerScreen.style.display = "block";

        }

        if (registerEmail) {

            registerEmail.value = email;

        }

    }

    function hideRegistrationScreen() {

        if (registerScreen) {

            registerScreen.style.display = "none";

        }

    }

    /*==========================================================
    Registration Form
    ==========================================================*/

    async function handleRegistrationSubmit(event) {

        event.preventDefault();

        clearMessage();

        const registration = {

            firstName:

                firstName.value.trim(),

            lastName:

                lastName.value.trim(),

            email:

                registerEmail.value.trim(),

            membership:

                document.querySelector(

                    'input[name="membership"]:checked'

                )?.value || "individual"

        };

        if (

            registration.firstName === "" ||

            registration.lastName === ""

        ) {

            showError(

                "Please complete all required fields."

            );

            return;

        }

        try {

            showLoading(true);

            const response =

                await TrestleAPI.registerUser(

                    registration

                );

            if (!response.success) {

                throw new Error(

                    response.message

                );

            }

            storeSession(

                response.data

            );

        }

        catch (error) {

            console.error(error);

            showError(

                error.message

            );

        }

        finally {

            showLoading(false);

        }

    }

    /*==========================================================
    Back Button
    ==========================================================*/

    function handleBack(event) {

        event.preventDefault();

        hideRegistrationScreen();

        clearMessage();

    }

    /*==========================================================
    Workspace Redirect
    ==========================================================*/

    function redirectToWorkspace() {

        window.location.href =

            "/pages/trestle-workspace";

    }

    /*==========================================================
    Email Validation
    ==========================================================*/

    function validateEmail(email) {

        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(

            email

        );

    }

    /*==========================================================
    Messages
    ==========================================================*/

    function showSuccess(message) {

        if (!messageBox) return;

        messageBox.className =

            "tr-success";

        messageBox.textContent =

            message;

    }

    function showError(message) {

        if (!messageBox) return;

        messageBox.className =

            "tr-error";

        messageBox.textContent =

            message;

    }

    function clearMessage() {

        if (!messageBox) return;

        messageBox.className = "";

        messageBox.textContent = "";

    }
    /*==========================================================
    Session Helpers
    ==========================================================*/

    function getSession() {

        return {

            userId:

                localStorage.getItem(

                    TrestleConfig.SESSION.USER_ID

                ),

            workspaceId:

                localStorage.getItem(

                    TrestleConfig.SESSION.WORKSPACE_ID

                ),

            sessionToken:

                localStorage.getItem(

                    TrestleConfig.SESSION.SESSION_TOKEN

                )

        };

    }

    function clearSession() {

        localStorage.removeItem(

            TrestleConfig.SESSION.STORAGE_KEY

        );

        localStorage.removeItem(

            TrestleConfig.SESSION.USER_ID

        );

        localStorage.removeItem(

            TrestleConfig.SESSION.WORKSPACE_ID

        );

        localStorage.removeItem(

            TrestleConfig.SESSION.SESSION_TOKEN

        );

    }

    /*==========================================================
    Utilities
    ==========================================================*/

    function disableButton(disabled) {

        if (!continueButton) return;

        continueButton.disabled = disabled;

    }

    function resetButton() {

        if (!continueButton) return;

        continueButton.disabled = false;

        continueButton.textContent = "Continue";

    }

    /*==========================================================
    Loading
    ==========================================================*/

    function showLoading(state) {

        disableButton(state);

        if (!continueButton) return;

        continueButton.textContent =

            state

                ? "Please wait..."

                : "Continue";

    }

    /*==========================================================
    Public Interface
    ==========================================================*/

    return {

        init,

        getState,

        getSession,

        clearSession

    };

})();

/*============================================================
Bootstrap
============================================================*/

document.addEventListener(

    "DOMContentLoaded",

    () => {

        TrestleAuth.init();

    }

);